<template>
  <div class="custom-tree-container">
    <div style="display: flex; align-items: center; margin-bottom: 10px;" v-if="userRole.includes('超级管理员')">
      <el-button type="primary" size="small" @click="handleInsert()">{{ $t('powerDomain.newP', { msg: 'powerDomain.newP' }) }}</el-button>
      <el-button type="danger" size="small" @click="handleDelete()" style="margin-left: 10px;">{{ $t('powerDomain.deleteP', { msg: 'powerDomain.deleteP' }) }}</el-button>
    </div>
    <el-tree
      v-loading="loading"
      :data="treeData"
      :props="{label: 'label', children: 'childrenList'}"
      :default-expand-all="false"
      font-size="30px"
    />
  </div>

    <el-dialog v-model="insertDialog" :title="$t('powerDomain.newP', { msg: 'powerDomain.newP' })">
      <el-form :model="insertForm" label-width="200px" :data="insertForm" label-position="left" :rules="newPowerRule" ref="insertForm">
        <el-form-item :label="$t('powerDomain.pId', { msg: 'powerDomain.pId' })" prop="id" >
          <el-input v-model="insertForm.id" @blur="getParentId()" :placeholder="$t('powerDomain.pIdD', { msg: 'powerDomain.pIdD' })" ref="id"></el-input>
        </el-form-item>
        <el-form-item :label="$t('powerDomain.fpId', { msg: 'powerDomain.fpId' })" prop="idParent">
          <el-input v-model="insertForm.idParent" :disabled="idParentDisabled" ref="idParentRef" :placeholder="$t('powerDomain.fpIdD', { msg: 'powerDomain.fpIdD' })"></el-input>
        </el-form-item>
        <el-form-item :label="$t('powerDomain.title', { msg: 'powerDomain.title' })" prop="title">
          <el-input v-model="insertForm.title" :placeholder="$t('powerDomain.titleD', { msg: 'powerDomain.titleD' })"></el-input>
        </el-form-item>
        <!-- <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="insertForm.companyName" placeholder="请输入公司名称"></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('powerDomain.cross', { msg: 'powerDomain.cross' })">
          <el-switch v-model="insertForm.setup" @click="handleSwitch()" class="left-switch"></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="insertPowerDomain('insertForm')">{{ $t('valueChain.new', { msg: 'valueChain.new' }) }}</el-button>
          <el-button type="danger" @click="handleInsertClose()">{{ $t('valueChain.cancel', { msg: 'valueChain.cancel' }) }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog v-model="deleteDialog" :title="$t('powerDomain.deleteP', { msg: 'powerDomain.deleteP' })" align-center="true" draggable="true" width="40%">
      <el-form :model="deleteForm" label-width="185px" :data="deleteForm" label-position="center" :rules="deletePowerRule" ref="deleteForm">
        <el-form-item prop="id" :rules="{required: true, message: this.$t('powerDomain.pIdP', { msg: 'powerDomain.pIdP' }), trigger: 'blur'}" :label="$t('powerDomain.pId', { msg: 'powerDomain.pId' })">
          <el-select v-model="deleteForm.id" @change="deleteIdChanged()" clearable style="width: 400px;" :placeholder="$t('powerDomain.place', { msg: 'powerDomain.place' })">
            <el-option v-for="item in level0"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="confirmId" :rules="{required: true, message: this.$t('powerDomain.pIdP', { msg: 'powerDomain.pIdP' }), trigger: 'blur'}" :label="$t('powerDomain.fpId', { msg: 'powerDomain.fpId' })">
          <el-select v-model="deleteForm.confirmId" @click="querySubLevel()" clearable style="width: 400px;" :placeholder="$t('powerDomain.place', { msg: 'powerDomain.place' })">
            <el-option v-for="item in subLevel"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="text-align: center;">
          <el-switch
            :active-text="$t('powerDomain.deleteUpDown', { msg: 'powerDomain.deleteUpDown' })"
            v-model="deleteForm.deleteRelation"
            style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949;margin: 0 auto;left: 74px"
            :active-value="1"
            :inactive-value="0"
            >
          </el-switch>
        </el-form-item>
      
        <el-form-item>
          <el-button type="primary" @click="deletePowerDomain('deleteForm')">{{ $t('powerDomain.d', { msg: 'powerDomain.d' }) }}</el-button>
          <el-button type="danger" @click="handleDeleteClose()">{{ $t('valueChain.cancel', { msg: 'valueChain.cancel' }) }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </template>
  
  <script>
import { baseUrl_New } from '../../axios/urlconfig';
import axios from 'axios';
import { getRequest, postRequest } from '../../axios/axios';
  export default {
    data() {
      return {
        treeData: [],
        loading: true,
        insertDialog: false,
        deleteDialog: false,
        idParentDisabled: true,
        parentId: '',
        level0: [],
        subLevel: [],
        userRole:'',

        insertForm: {
          id: '',
          idParent: '',
          title: '',
          companyName: '',
          setup: 0,
        },

        deleteForm: {
          id: '',
          confirmId: '',
          deleteRelation: '0',
        },

        newPowerRule: {
        id: [
          { required: true, message: this.$t('powerDomain.pIdP', { msg: 'powerDomain.pIdP' }), trigger: 'blur' },
          { pattern: /^[0-9.]+$/, message: this.$t('powerDomain.info', { msg: 'powerDomain.info' }), trigger: 'blur'}
        ],
        idParent: [
          { required: false, message: '', trigger: 'blur' },
          { pattern: /^[0-9.]+$/, message: this.$t('powerDomain.info', { msg: 'powerDomain.info' }), trigger: 'blur'}
        ],
        title: [
          { required: true, message: this.$t('powerDomain.titleD', { msg: 'powerDomain.titleD' }), trigger: 'blur' }
        ],
        companyName: [
          { required: false, message: this.$t('valueChain.companyD', { msg: 'valueChain.companyD' }), trigger: 'blur' }
        ]
        },

      };
    },

    created() {
      this.fetchData();
      this.selectLevel0();
      this.getUserRole();
    },

    methods: {

      fetchData() {
        getRequest(baseUrl_New + '/power/list')
        .then(response => {
            // console.log(response);
            this.treeData = response;
            this.loading = false;
        }).catch(err => {
            console.log(err);
        })
      },

      handleInsert(){
        this.insertDialog = true;
        this.$refs.id.onfocus = true;
      },

      handleInsertClose(){
        this.insertForm.id = '';
        this.insertForm.idParent = '';
        this.insertForm.title = '';
        this.insertForm.companyName = '';
        this.insertForm.setup = false;
        this.insertDialog = false;
      },

      handleDelete(){
        this.deleteDialog = true;
      },

      handleDeleteClose(){
        this.deleteForm.id = '';
        this.deleteForm.confirmId = '';
        this.deleteForm.deleteRelation = '0';
        this.deleteDialog = false;
      },

      insertPowerDomain(formName){
        this.$refs[formName].validate((valid) => { 
        if (valid) {
        postRequest(baseUrl_New + "/power/insert",this.insertForm).
        then(res => {
          console.log(res);
          if(res === "新增成功"){
            this.$message.success(this.$t('issue.addS', { msg: 'issue.addS' }));
            this.handleInsertClose();
            this.fetchData();
          }else{
            this.$message.error(res);
          }
        }).catch(err => {
          console.log(err);
        })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      },

      deletePowerDomain(formName){
        this.$refs[formName].validate((valid) => { 
        if (valid) {
        postRequest(baseUrl_New + "/power/delete",this.deleteForm)
        .then(res => {
          if(res === "删除成功"){
            this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }));
            this.handleDeleteClose();
            this.fetchData();
          }else {
            this.$message.error('删除失败');
          }
        }).catch(err => {
          this.$message.error(err);
          console.log(err);
        })
        }
      });
      },

      getParentId(){
        let result =  this.insertForm.id.substring(0,this.insertForm.id.lastIndexOf('.'));
        this.insertForm.idParent = result;
      },

      handleSwitch(){
        if(this.insertForm.setup === true){
          this.idParentDisabled = false;
        }else{
          this.idParentDisabled = true;
        }
      },

      selectLevel0(){
        getRequest(baseUrl_New + "/power/level0").
        then(res => {
          for(let i = 0;i < res.length; i++){
          this.level0.push({
            label: res[i],
            value: res[i],
            text: res[i]
          })
        }
        }).
        catch(err => {
          console.log(err);
        })
      },

      querySubLevel(){
        this.subLevel.splice(0,this.subLevel.length);
        getRequest(baseUrl_New + "/power/sublevel/" + this.deleteForm.id.split(':')[0]).
        then(res => {
          for(let i = 0;i < res.length; i++){
          this.subLevel.push({
            label: res[i],
            value: res[i],
            text: res[i]
          })
        }
        }).
        catch(err => {
          console.log(err);
        })
      },

      deleteIdChanged(){
        this.deleteForm.confirmId = '';
      },

      getUserRole(){
          this.userRole=sessionStorage.getItem('role');
        },

        
    }
  };
  </script>

<style>
		
/* 将开关靠左显示 */
.el-switch {
  display: flex;
  align-items: center;
}			

/* 调整标签样式以对齐开关 */
.el-form-item__label {
  line-height: 20px; /* 调整标签的行高 */
}
</style>
